import { combineReducers } from 'redux';
import roleRequestReducer from './reducers/addRole';
import staticDataReducer from './reducers/staticData';
import userSlice from './reducers/userSlice';
import auditeeReducer from './reducers/Audit';
import bankReducer from './reducers/bankSlice';

const rootReducer = combineReducers({
  user: userSlice,
  staticData: staticDataReducer,
  roleRequest: roleRequestReducer,
  auditee: auditeeReducer,
  bank: bankReducer,
});

export default rootReducer;
